import PropTypes from 'prop-types'

import AssistedSaleProductContent from './AssistedSaleProductContent'
import AssistedSaleProductInfo from './AssistedSaleProductInfo'
import AssistedSaleContentManager from './AssistedSaleContentManager'

const AssistedSaleMobileThumb = ({ product }) => {
  const {
    id,
    name,
    picture,
    unit,
    price,
    installments,
    tag,
    offer,
    url,
    assistedSale
  } = product

  const typeClass = offer ? `type-${offer.type}` : ''
  const productThumbClass = `new-product-thumb-assisted-sale ${typeClass}`

  return (
    <div className={productThumbClass}>
      <div className="assisted-sale-thumb-header">
        <AssistedSaleProductContent
          badge={tag}
          picture={picture}
          url={url}
        />
        <AssistedSaleProductInfo
          name={name}
          id={id}
          url={url}
          assistedSale={assistedSale}
          offer={offer}
          price={price}
          installments={installments}
          unit={unit}
        />
      </div>
      <div className="assisted-sale-thumb-footer">
        <AssistedSaleContentManager
          id={id}
          assistedSale={assistedSale}
          unit={unit}
          isMobileContext
          price={price}
        />
      </div>
    </div>
  )
}

AssistedSaleMobileThumb.propTypes = {
  id: PropTypes.number,
  picture: PropTypes.string,
  unit: PropTypes.string,
  price: PropTypes.shape({
    from: PropTypes.shape({
      integers: PropTypes.string,
      decimals: PropTypes.string
    }),
    to: PropTypes.shape({
      integers: PropTypes.string,
      decimals: PropTypes.string
    }).isRequired
  }),
  installments: PropTypes.shape({
    amount: PropTypes.number,
    value: PropTypes.string
  }),
  tag: PropTypes.shape({
    type: PropTypes.string,
    label: PropTypes.string
  }),
  offer: PropTypes.shape({
    type: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string
  }),
  url: PropTypes.string,
  assistedSale: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.string),
    stock: PropTypes.shape({
      store: PropTypes.number,
      warehouse: PropTypes.number
    })
  })
}

export default AssistedSaleMobileThumb
